import 'bootstrap-icons/font/bootstrap-icons.css'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6'
import { RouterProvider } from 'react-router-dom'
import './App.css'

import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'


import { router } from './lib/router/router'

import * as Sentry from '@sentry/react'

import { Toaster } from "@/components/ui/sonner"
import Clarity from '@microsoft/clarity'
import { useEffect } from 'react'
import { DynamicDialogProvider } from './components/ui/dynamic-dialog'
import { ENV } from './constants/env'


const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    // onSuccess: (_data, _variables, _context, mutation) => {
    //   queryClient.invalidateQueries({
    //     queryKey: mutation.options.mutationKey,
    //   })
    // },
    onError: (error) => {
      Sentry.captureException(error);
      console.error(error);
    }
  }),
  defaultOptions: {
    queries: {
      // staleTime: 1000 * 60 * 2, // 2 minutes
    }
  },
  queryCache: new QueryCache({
    onError: (error) => {
      Sentry.captureException(error);
      console.error(error);
    },
  })
});

function App() {
  useEffect(() => {
    Clarity.init(ENV.VITE_MS_CLARITY_PROJECT_ID);
  }, [])
  return (
    <QueryClientProvider client={queryClient} >
      <div className='flex flex-col h-full min-h-screen'>
        <div className="flex flex-1">
          <div className="flex flex-col flex-1">
            <NuqsAdapter>
              <RouterProvider router={router} />
              <DynamicDialogProvider />
            </NuqsAdapter>
          </div>

        </div>
      </div>
      <Toaster />
      <ReactQueryDevtools initialIsOpen={false} position='right' buttonPosition='bottom-right' />
    </QueryClientProvider>
  )
}

export default App
